import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import fssai from '../../../assets/images/fssai.png';
import veg from '../../../assets/images/veg.png';
import noartf from '../../../assets/images/noartf.png';

const FeatureList = () => (
  <div className="list">
    <Container className='shadow-sm py-5'>
      <Row>
        <Col sm={12} md={4} className="column">
          <div className="d-flex align-items-center">
            <img src={fssai} alt="logo" width="100px" className="me-3" />
            <div className='text-start'>
              <h5 className="mb-2 heading fw-bold">FSSAI Certified Facility</h5>
              <p className="mb-0 para">Approved. Trusted. Safe</p>
            </div>
          </div>
        </Col>
        <Col sm={12} md={4} className="column">
          <div className="d-flex align-items-center">
            <img src={noartf} alt="logo" width="80px" className="me-3" />
            <div className='text-start'>
              <h5 className="mb-2 heading fw-bold">No artificial colors or flavors</h5>
              <p className="mb-0 para">Naturally delicious</p>
            </div>
          </div>
        </Col>
        <Col sm={12} md={4} className="column">
          <div className="d-flex align-items-center">
            <img src={veg} alt="logo" width="80px" className="me-3" />
            <div className='text-start'>
              <h5 className="mb-2 heading fw-bold">100% vegetarian ingredients</h5>
              <p className="mb-0 para">Purely plant-based goodness</p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

export default FeatureList;